let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("9eNkX"), load("dh2Er"), load("k10Cs"), load("1pFHs"), load("8Mz40"), load("l6YHr")]).then(() => parcelRequire('ttXag'));